import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=55163429&scoped=true&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"
import style0 from "./Header.vue?vue&type=style&index=0&id=55163429&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55163429",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55163429')) {
      api.createRecord('55163429', component.options)
    } else {
      api.reload('55163429', component.options)
    }
    module.hot.accept("./Header.vue?vue&type=template&id=55163429&scoped=true&", function () {
      api.rerender('55163429', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/contacts/components/Header.vue"
export default component.exports